import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Modal from '@material-ui/core/Modal';
import { useSelector } from 'react-redux';
import { PPI } from '@ikea-food-ux/ppsi';
import { stitchPpi } from '../../../utils/ui2pStitchPPI';
import { getOverviewLabels } from '../../app/overviewLabelSelectors';
import { getProductions } from '../../app/productionSelectors';
import { getStockHierarchy } from '../../app/stockHierarchySelectors';
import { getTemperatureUnits } from '../../app/temperatureUnitSelectors';
import { getTimeUnits } from '../../app/timeUnitSelectors';
import { getShelfLifeTimeUnitsUnits } from 'features/app/shelfLifeTimeUnitsSelectors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    width: '90%',
    minWidth: 600,
    maxWidth: 1024,
    maxHeight: '90%',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    outline: 0,
    borderRadius: '3px'
  }
}));

const usePreviewPpi = () => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState();
  const labels = useSelector(getOverviewLabels).toJS();
  const timeUnits = useSelector(getTimeUnits).toJS();
  const temperatureUnits = useSelector(getTemperatureUnits).toJS();
  const stockHierarchy = useSelector(getStockHierarchy).toJS();
  const productionOptions = useSelector(getProductions).toJS();
  const shelfLifeTimeUnits = useSelector(getShelfLifeTimeUnitsUnits).toJS();

  function open(ppiData, language) {
    setIsOpen(true);
    const ppi = stitchPpi(ppiData);
    const ingredient = ppiData.referencedIngredientData;
    setData({ ppi, ingredient, language });
  }
  function close() {
    setIsOpen(false);
    setData(null);
  }

  const element = (
    <Modal open={isOpen} onClose={close} className={classes.root}>
      <div className={classes.content} id="scrollable">
        {data && data.ppi ? (
          <PPI
            ppi={data.ppi}
            ingredient={data.ingredient}
            labels={labels}
            timeUnits={timeUnits}
            temperatureUnits={temperatureUnits}
            stockHierarchy={stockHierarchy}
            productionOptions={productionOptions}
            language={data.language}
            navigateIcon={null}
            shelfLifeTimeUnits={shelfLifeTimeUnits}
          />
        ) : (
          <>No PPI Data :(</>
        )}
      </div>
    </Modal>
  );

  return [element, open, close];
};

export default usePreviewPpi;
